module.exports = __webpack_public_path__ + "img/house-person-leave.bf639241.svg";